export enum LocalStorageItems {
  AccessToken = 'access-token',
  RefreshToken = 'refresh-token',
  SexOffenderDueLoginSessionId = 'sex-offender-due-login-session-id',
  CurrentAgencyId = 'current-agency-id',
  ExpandedUnitItems = 'expanded-unit-items',
  UnitShiftListCurrentTab = 'unit-shift-list-current-tab',
  UnitShiftListOpen = 'unit-shift-list-open',
  UnitShiftsOpenStyle = 'unit-shifts-open-style',
  ManageUnitsOpenStyle = 'manage-units-open-style',
  FullVersionSidebar = 'full-version-sidebar',
  ExpandedSidebar = 'expanded-sidebar',
  TimelineFilterEvents = 'timeline_filter_events',
  DeviceUID = 'device-uid',
  UnitsShowDeleted = 'units-show-deleted',
  ShowInactiveEmployees = 'show-inactive-employees',
  LogoutOnClose = 'logout-on-close',
  LastHeartbeat = 'last-heartbeat',
}

export enum LocalStoragePrefix {
  TableSetting = 'table-setting',
  MasterIndexTableSetting = 'master-index-table-setting',
  UnitFilters = 'unit-filters',
  CfsTimelineFilters = 'cfs-timeline-filters',
  SexOffenderDueNotification = 'sex-offender-due-notification',
}
